import keyMirror from 'fbjs/lib/keyMirror';
import { createStore } from 'fluxible/addons';
import { fromJS, is } from 'immutable';

export const toSnakeCase = (string) => string
  .replace(/[^\w\s]/g, '')
  .replace(/^[A-Z]/, (str) => str.toLowerCase())
  .replace(/[A-Z]/g, (str) => `_${str.toLowerCase()}`);

export function actionGenerator(displayName, actions) {
  return Object.assign((context, payload) => new Promise(async (resolve, reject) => {
    const actionType = payload.get('type');
    const action = actions[actionType];
    if (!action) {
      return reject(new Error(`Invalid action type executed on ${displayName}.`));
    }
    try {
      resolve(await action({ context, payload }));
    } catch (error) {
      reject(Object.assign(error, { message: `${error.message} (at ${displayName}::${actionType})` }));
    }
    return null;
  }), { displayName, actionTypes: keyMirror(actions) });
}

export function storeGenerator(storeName, properties) {
  return Object.assign(createStore(Object.assign({ storeName, ...properties }, {
    initialize() {
      if (properties.initialize) {
        properties.initialize.call(this);
      }
      Object.defineProperty(this, 'data', {
        enumerable: false,
        writable: true,
        configurable: false,
        value: fromJS(properties.defaults || {}),
      });
    },

    has(paths) {
      return this.data.hasIn(Array.isArray(paths) ? paths : [paths]);
    },

    get(paths) {
      return this.data.getIn(Array.isArray(paths) ? paths : [paths]);
    },

    set(paths, data) {
      if (typeof paths === 'undefined') {
        throw new Error('store.set requires 2 argument');
      }
      if (!is(this.get(paths), data)) {
        Object.defineProperty(this, 'data', {
          enumerable: false,
          writable: true,
          configurable: false,
          value: this.data.setIn(Array.isArray(paths) ? paths : [paths], data),
        });
        this.emitChange();
      }
    },

    dehydrate() {
      return this.data.toJS();
    },

    rehydrate(dehydrated) {
      this.data = fromJS(dehydrated);
    },
  })), { dispatchTypes: keyMirror(properties.handlers) });
}



// WEBPACK FOOTER //
// ./src/app/utils/Generator/Generator.js